import printerInstance from '../instance'

const getAutoPrintConfigs = (module, businessScope) => {
  return printerInstance.get(`/autoPrintConfigs/${module}` + (businessScope ? '?businessScope=' + businessScope : ''))
}

export default getAutoPrintConfigs
